import * as yup from 'yup';

export const clusterNameRules = {
  max: 256,
  pattern: /^[A-Za-z0-9_-]*$/,
} as const;

export const clusterSizeRules = {
  min: 15,
  max: 100,
  pattern: /^[A-Za-z0-9_-]*$/,
} as const;

export const clusterIopsRules = {
  min: 3000,
  max: 16000,
  pattern: /^[A-Za-z0-9_-]*$/,
} as const;

export const clusterThroughputRules = {
  min: 125,
  max: 1000,
  pattern: /^[A-Za-z0-9_-]*$/,
} as const;

export const clusterSchema: yup.AnyObjectSchema = yup
  .object({
    name: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .max(clusterNameRules.max, `Cluster name should contain up to ${clusterNameRules.max} characters`)
      .matches(clusterNameRules.pattern, 'Only alphanumeric characters, underscore, and hyphen are allowed')
      .required('Cluster name is a required field'),
    primary_ec2_instance_type: yup.string().required('Primary EC2 instance type is a required field'),
    core_ec2_instance_type: yup
      .string()
      .max(256, 'Core EC2 instance type should contain up to 256 characters')
      .required('Core EC2 instance type is a required field'),
    ebs_size: yup
      .number()
      .transform((value, originalValue) => (originalValue === '' || originalValue == null ? undefined : value))
      .min(clusterSizeRules.min, `Size should be at least ${clusterSizeRules.min} GiB`)
      .max(clusterSizeRules.max, `Size should be at most ${clusterSizeRules.max} GiB`)
      .typeError('Size is a required field')
      .required('Size is a required field'),
    ebs_iops: yup
      .number()
      .transform((value, originalValue) => (originalValue === '' || originalValue == null ? undefined : value))
      .min(clusterIopsRules.min, `IOPS should be at least ${clusterIopsRules.min}`)
      .max(clusterIopsRules.max, `IOPS should be at most ${clusterIopsRules.max}`)
      .typeError('IOPS is a required field')
      .required('IOPS is a required field'),
    ebs_throughput: yup
      .number()
      .transform((value, originalValue) => (originalValue === '' || originalValue == null ? undefined : value))
      .min(clusterThroughputRules.min, `Throughput should be at least ${clusterThroughputRules.min}`)
      .max(clusterThroughputRules.max, `Throughput should be at most ${clusterThroughputRules.max}`)
      .typeError('Throughput is a required field')
      .required('Throughput is a required field'),
  })
  .required();
